import React, { Suspense, useEffect, useRef, useState } from 'react';
import Head from 'next/head';
import classNames from 'classnames/bind';
import PageHeaderComponent from '../../components/Base/PageHeaderComponent';
import LazyLoad from 'react-lazyload';
import ViewMore from '../../components/ViewMore';
import SolveProblems from '../../components/saas/SolveProblems';
import Problems from '../../components/saas/Problems';
import st from './index.module.scss';
import Pricing from '../../components/video-production/Pricing';

const SAASVideos = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  // const [loadedPricingModal,setLoadedPricingModal] = useState(false)

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      // document.getElementById('pricing-form').reset();
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    // setLoadedPricingModal(false)
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - SaaS Videos | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/SAAS-videos" />
        <meta
          name="description"
          content="Showcase your SaaS solutions with Prodigi's engaging videos. Simplify complex concepts and captivate your audience effectively."
        />
        <meta property="og:url" content="https://weprodigi.com/SAAS-videos" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - SaaS Videos | Prodigi" />
        <meta
          property="og:description"
          content="Showcase your SaaS solutions with Prodigi's engaging videos. Simplify complex concepts and captivate your audience effectively."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/saas/meta2.png" />
      </Head>
      <PageHeaderComponent
        width={props.width}
        url={'https://weprodigi.com/uploads/images/saas/Saas_desktop_2 mb.mp4'}
        text="SAAS video production services"
      />
      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container flex flex-wrap md:flex-nowrap justify-between">
            <div className="w-full md:w-half-auto hidden md:block">
              <img src="https://weprodigi.com/uploads/images/healthcare/healthcare2_21.jpg" width={'100%'} height={100} alt="we rock digital" />
            </div>
            <div className="w-full md:w-half-auto mt-18 md:mt-0  hidden md:block">
              Since SaaS is non-material, it can be hard to explain in a nutshell. This is where videos come to the rescue. Video is a godsend for
              SaaS marketers as presenting a product with a 2-minute video is much easier than with a 1000-word guideline. Through animated stories,
              you can create a great user experience and an image that sticks in the users’ minds. Hundreds of SaaS product categories have their
              specifics and characteristics, and all have their target audiences. Whether a SaaS company has B2B or B2C marketing, multiform content
              delivery, and omnichannel marketing is the key to getting better reach and conversion. So how can video production facilitate SaaS
              marketing, what problems does it solve, and how does it create killer videos?{' '}
            </div>
            <div className="w-full md:w-half-auto mt-18 md:mt-0  block md:hidden">
              <ViewMore ln={40}>
                Since SaaS is non-material, it can be hard to explain in a nutshell. This is where videos come to the rescue. Video is a godsend for
                SaaS marketers as presenting a product with a 2-minute video is much easier than with a 1000-word guideline. Through animated stories,
                you can create a great user experience and an image that sticks in the users’ minds. Hundreds of SaaS product categories have their
                specifics and characteristics, and all have their target audiences. Whether a SaaS company has B2B or B2C marketing, multiform content
                delivery, and omnichannel marketing is the key to getting better reach and conversion. So how can video production facilitate SaaS
                marketing, what problems does it solve, and how does it create killer videos?
              </ViewMore>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What is SaaS video animation?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <video controls poster={'https://weprodigi.com/uploads/images/saas/video1.jpg'}>
                  <source src="https://weprodigi.com/uploads/images/saas/DataMonkeys_IsometricExplainerVideoByProDigi.mp4" type="video/mp4" />
                </video>
                {/*<p className={"font-medium text-14 leading-24 text-center mt-8 text-gray-dark"}>Spondylitis Association of America | Explainer Video</p>*/}
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                Whether introducing a brand-new tech application or designing a ground-breaking engineering project, chances are your audience might
                not understand your product at first glance. Moreover, if your marketing campaigns generate a lot of qualified traffic but result in
                low conversions, it's because your audience is simply confused. No matter how great your product is, if people don't understand what
                value it brings in terms of increased profits or decreased costs, they cannot justify the price. The simple solution that would cover
                this gap is technology video. Feature your SaaS or technology video on your website, product or service pages, lobby display, social
                media, email, trade shows, sales meetings, and anywhere you can display it to help your audience understand how your technology works.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  Whether introducing a brand-new tech application or designing a ground-breaking engineering project, chances are your audience might
                  not understand your product at first glance. Moreover, if your marketing campaigns generate a lot of qualified traffic but result in
                  low conversions, it's because your audience is simply confused. No matter how great your product is, if people don't understand what
                  value it brings in terms of increased profits or decreased costs, they cannot justify the price. The simple solution that would
                  cover this gap is technology video. Feature your SaaS or technology video on your website, product or service pages, lobby display,
                  social media, email, trade shows, sales meetings, and anywhere you can display it to help your audience understand how your
                  technology works.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What video types are used for SaaS products?
            </h2>
            <p className={'mt-20'}>
              Whether you want to increase customer acquisition, raise awareness and engagement or fix the retention rate, there is a SaaS video for
              each sale funnel stage to help you address your problems.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <video width="540" controls className="w-full" poster={'https://weprodigi.com/uploads/images/saas/video2.jpg'}>
                  <source
                    src="https://weprodigi.com/uploads/images/saas/MobilityStream_SoftwareSolutions_ExplainerVideoByProdigi.mp4"
                    type="video/mp4"
                  />
                </video>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Mobility Stream | Screencast Video</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Demo Screencast Videos</h3>
                <div className={'mt-16 hidden md:block'}>
                  We do love to see what we get, and a demo screencast video is just what can convince us. When it comes to SaaS products, a demo
                  video can go deep into the whole functionality and the benefits. Such video can be used for presentations and marketing campaigns on
                  your landing page or sent to your users. Screencast videos can be incorporated into marketing at any stage of product development.
                  It means your SaaS video can be a demo, product update video, or a new feature announcement. Using a product demo video to explain
                  the benefits of your SaaS will help you explain which problems it solves
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    We do love to see what we get, and a demo screencast video is just what can convince us. When it comes to SaaS products, a demo
                    video can go deep into the whole functionality and the benefits. Such video can be used for presentations and marketing campaigns
                    on your landing page or sent to your users. Screencast videos can be incorporated into marketing at any stage of product
                    development. It means your SaaS video can be a demo, product update video, or a new feature announcement. Using a product demo
                    video to explain the benefits of your SaaS will help you explain which problems it solves
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Explainer Videos</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  A product explainer video lets you provide an in-depth overview of your offer and highlight its benefits to your audience. The
                  animation will allow you to grasp even the most abstract ideas and processes with maximum impact. Unlike screencast videos,
                  explainer videos include more animation and interaction, having a greater impact on users. The main goal of an explainer video for a
                  SaaS product is to address the target audience's pain points and reveal all the use cases that can be solved with the product.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    A product explainer video lets you provide an in-depth overview of your offer and highlight its benefits to your audience. The
                    animation will allow you to grasp even the most abstract ideas and processes with maximum impact. Unlike screencast videos,
                    explainer videos include more animation and interaction, having a greater impact on users. The main goal of an explainer video for
                    a SaaS product is to address the target audience's pain points and reveal all the use cases that can be solved with the product.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <video width="540" controls className="w-full  " poster={'https://weprodigi.com/uploads/images/saas/video3.jpg'}>
                  <source
                    src="https://weprodigi.com/uploads/images/saas/ScoutelyISoftwareSolutionsI2DCharacterAnimationbyProdigi.mp4"
                    type="video/mp4"
                  />
                </video>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Scoutely | Explainer Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <video width="540" controls className="w-full" poster={'https://weprodigi.com/uploads/images/saas/video4.jpg'}>
                  <source
                    src="https://weprodigi.com/uploads/images/saas/MatadorBroadcast_SoftwareSolutions_ExplainerVideoByProdigi.mp4"
                    type="video/mp4"
                  />
                </video>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Matador Broadcast | Promo Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Promo videos</h3>
                <p className={'mt-16 hidden md:block'}>
                  So far, the best content type for SaaS marketing with proven efficiency is promo video targeting audiences through digital marketing
                  channels. Short, captivating videos explaining and presenting a SaaS product for social channels and promoted as ads on other
                  platforms will help lead customers through the sales funnel with final conversion.{' '}
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    So far, the best content type for SaaS marketing with proven efficiency is promo video targeting audiences through digital
                    marketing channels. Short, captivating videos explaining and presenting a SaaS product for social channels and promoted as ads on
                    other platforms will help lead customers through the sales funnel with final conversion.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What are the problems of <br />
              the SaaS industry?
            </h2>
            <p className={'mt-20'}>
              Most SaaS companies encounter marketing and sales challenges because they aren't sure who their target customers are or how to reach
              them. Another challenge can be getting your product noticed in a crowded market. Having so many options makes choosing the right service
              more difficult.{' '}
            </p>
            <Suspense fallback={`Loading...`}>
              <Problems />
            </Suspense>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How can SaaS video production solve these problems?
            </h2>
            <p className={'mt-20'}>You got problems, and video production got solutions.</p>
            <Suspense fallback={`Loading...`}>
              <SolveProblems />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div className={'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-36'}>
              YOUR SAAS VIDEO COST <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/saas/Eva.webp" alt="eva" />
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={0} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How to Choose the Right Video Production Agency for your SaaS video?
            </h2>
            <p className={'mt-20'}>
              The value of your product should be presented with equal valuable video. A professional production company that understands tech and has
              relevant expertise in the industry can handle the task and “wrap” your complex software in an appealing cover. Choose wisely a video
              production agency that will help you draw your concept and create a script and storyboard with clear messaging. Another detail to keep
              your focus on is custom video production without templates; otherwise, your video will get lost just like the product.
            </p>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad once height={300}>
        <div className={` scale-y-1  height-transition `}>
          <div className={'bg-review  mt-20 md:mt-0 ' + st['review-3']}>
            <div className={'container mt-0 md:mt-0 h-full flex flex-wrap md:flex-nowrap justify-between items-center pb-30 md:pb-0'}>
              <div className={'w-full md:w-auto mt-0 md:mt-0  py-24'}>
                <p className={'text-white md:text-white text-20 md:text-32 leading-24 md:leading-39 font-400 max-w-650'}>
                  We've driven <span className={'text-green font-bolder'}>86,300,000 video views</span> for our clients through video production
                  services.
                </p>
                <p className="text-white md:text-white font-normal-700 text-20 md:text-32 leading-24 md:leading-39">
                  Discover how we can help your business
                </p>
                {/*<button className={'w-full md:w-auto mt-24 text-white bg-green rounded-5 px-23 py-5'}>Send me a proposal</button>*/}
                <div className={'w-full hidden md:flex'}>
                  <a
                    href={'https://weprodigi.com/video-production'}
                    className="text-center capitalize hover:bg-purple-overlay  block w-full md:w-auto mt-24 text-white bg-purple rounded-5 px-23 py-5"
                  >
                    see full service
                  </a>
                  <a
                    className="hidden ml-20  hover:bg-green-hover md:block w-full md:w-auto mt-24 text-white bg-green rounded-5 px-23 py-5"
                    href={'https://calendar.app.google/uJZkJfztLwHZcfkC7'}
                    target={'_blank'}
                  >
                    {' '}
                    Schedule a Call
                  </a>
                  <a
                    className="block  hover:bg-green-hover md:hidden text-center w-full md:w-auto mt-24 text-white bg-green rounded-5 px-23 py-5"
                    href={'https://calendar.app.google/uJZkJfztLwHZcfkC7'}
                    target={'_blank'}
                  >
                    {' '}
                    Schedule a Call
                  </a>
                </div>
              </div>
              <div className={'w-full md:w-auto  md:block pl-0 md:pl-40'}>
                <p className="text-white font-normal-700 text-18 md:text-18 leading-28 mb-10 md:mb-0 md:leading-39">
                  What our video production clients say
                </p>
                <div className="bg-white shadow-lg min-h-280 md:min-h-250   card-rounded py-25 px-14 flex justify-start items-start relative">
                  <img
                    src="https://weprodigi.com/uploads/images/home-page/Formatquote.svg"
                    className={'-mt-12'}
                    width={55}
                    height={55}
                    alt="format quote"
                  />
                  <div className={'relative max-w-320'}>
                    <p className={'text-black text-16 leading-20 font-400'}>
                      Their creativity and passion for the project is impressive. Their ability to work to tight schedules and meet deadlines. Their
                      ability to think outside the box especially during the COVID-19 restrictions .
                    </p>
                    <p className={'text-purple text-16 leading-20 font-bolder mt-16'}>Johnson Samuyiwa, Director </p>
                    <p className="text-black  text-16 leading-20  mt-8">SelectTVFormats LTD</p>
                  </div>
                  <a
                    aria-label={'view more'}
                    href="https://clutch.co/profile/weprodigi-agency?page=3&project_cost=&review_type=&service_provided=&sort_by=date_DESC#review-1651937"
                    target={'_blank'}
                    className={'text-purple text16 font-bolder flex items-center absolute bottom-15 hover-arrow right-30'}
                  >
                    More
                    <svg xmlns="http://www.w3.org/2000/svg" width={18} viewBox="0 0 20 20" fill="currentColor">
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </a>
                </div>
                <div className={'w-full flex md:hidden'}>
                  <a
                    href={'https://weprodigi.com/video-production'}
                    target={'_blank'}
                    className="text-center text-16 capitalize hover:bg-purple-overlay  block w-full md:w-auto mt-24 text-white bg-purple rounded-5  px-0 md:px-23 py-5"
                  >
                    see full service
                  </a>
                  <a
                    className="block  md:hidden text-center text-16 w-full md:w-auto mt-24 ml-20 text-white bg-green hover:bg-green-hover rounded-5 px-none md:px-23 py-5"
                    href={'https://calendar.app.google/uJZkJfztLwHZcfkC7'}
                    target={'_blank'}
                  >
                    Get Pricing
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <Pricing from={'SAAS'} videoLength={[]} script={''} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default SAASVideos;
